// Modules
import React, { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'

// Hooks
// import useLanguage from 'hooks/system/useLanguage'
import useNotices from 'hooks/system/useNotices'
import useTheme from 'hooks/system/useTheme'

// Utilities
import { uppercaseFirst } from 'utilities/text'

// Constants
import { SSO_REDIRECT_URL } from 'constants/environment'

// Styles
import './AppleIdentity.scss'

// Data (Local)
const typeButtonPropertyMapping = {
	continue: 'continue',
	signUp: 'sign-up',
	signIn: 'sign-in'
}

// Component: External > Apple identity
function AppleIdentity ({ className, isDisabled, isInitialized, onResponse, style, type }) {
	// State
	const [hasError, setHasError] = useState(false)

	// Data
	const { theme } = useTheme()
	const { addNotice } = useNotices()
	// const { language } = useLanguage('components.external.providerButton.components.appleIdentity')

	// Functions (Memoized)
	const handleClick = useCallback(async () => {
		try {
			const data = await window.AppleID.auth.signIn()
			if (!!data) onResponse(data)
		} catch (error) {
			if (error.error === 'popup_blocked_by_browser') {
				addNotice({
					code: `client.apple${uppercaseFirst(type)}PopupBlockedError`,
					log: error,
					type: 'error'
				})
			}
			else if (error.error !== 'popup_closed_by_user') addNotice({ code: 'client.providerAuthenticationError', log: error, type: 'error' })
		}
	}, [addNotice, onResponse, type])

	// Effects
	useEffect(() => {
		let script
		if (isInitialized) {
			if (!!window.AppleID) {
				if (!document.getElementById('apple-identity-configuration-script')) {
					script = document.createElement('script')
					script.id = 'apple-identity-configuration-script'
					script.type = 'text/javascript'
					script.innerHTML = `AppleID.auth.init({ clientId : 'com.aixplain.auth', scope : 'email name', redirectURI : '${SSO_REDIRECT_URL}', usePopup : true })`
					document.head.appendChild(script)
				}
			} else setHasError(true)
		}
		return () => {
			if (!!script) document.head.removeChild(script)
			Array
				.from(document.querySelectorAll('[id="apple-identity-configuration-script"]'))
				.forEach(itemToRemove => itemToRemove.parentElement.removeChild(itemToRemove))
		}
	}, [isInitialized])
	/*
	useEffect(() => {
		function handleSuccess (event) {
			console.log('handleSuccess', event.detail.data)
		}
		function handleFailure (event) {
			console.log('handleFailure', event.detail.error)
		}
		document.addEventListener('AppleIDSignInOnSuccess', handleSuccess)
		document.addEventListener('AppleIDSignInOnFailure', handleFailure)
		return () => {
			document.removeEventListener('AppleIDSignInOnSuccess', handleSuccess)
			document.removeEventListener('AppleIDSignInOnFailure', handleFailure)
		}
	}, [])
	*/

	// Render
	if (!isInitialized || hasError) return null
	return (
		<span
			data-component="apple-identity"
			className={
				'aix-apple-identity' +
				(className ? ` ${className}` : '')
			}
			style={style}>
			<div
				id="appleid-signin"
				data-color={theme === 'dark' ? 'black' : 'white'}
				data-border="false"
				data-height="38"
				data-border-radius="3"
				data-type={typeButtonPropertyMapping[type] || 'continue'}
				onClick={handleClick}>
			</div>
		</span>
	)
}

// Properties
AppleIdentity.propTypes = {
	className: PropTypes.string,
	isDisabled: PropTypes.bool,
	isInitialized: PropTypes.bool.isRequired,
	onResponse: PropTypes.func.isRequired,
	style: PropTypes.object,
	type: PropTypes.oneOf(['continue', 'signUp', 'signIn'])
}

// Export
export default AppleIdentity
